/*
 *
 * AbsenceMobile actions
 *
 */

import {
  FLUSH_STATE_ABSENCEMOBILE,
  LOAD_ABSENCES,
  LOAD_ABSENCES_SUCCESS,
  LOAD_ABSENCES_ERROR,
  CHANGE_ABSENCE,
  CHANGE_ABSENCE_SUCCESS,
  CHANGE_ABSENCE_ERROR,
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
} from './constants';

/**
 * Clearing the state for AbsenceMobile
 */
export function flushStateAbsenceMobile() {
  return {
    type: FLUSH_STATE_ABSENCEMOBILE,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the AbsenceMobile, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_ABSENCES
 */
export function loadAbsencesMobile(role, child) {
  return {
    type: LOAD_ABSENCES,
    role,
    child
  };
}

/**
 * Dispatched when the loadAbsenceMobile are loaded by the request saga
 *
 * @param  {array} variables true for AbsenceMobile
 *
 * @return {array} An action object with a type of LOAD_ABSENCES_SUCCESS passing the variables
 */
export function loadAbsencesMobileSuccess(absenceList) {
  return {
    type: LOAD_ABSENCES_SUCCESS,
    absenceList
  };
}

/**
 * Dispatched when loading the loadAbsenceMobile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_ABSENCES_ERROR passing the error
 */
export function loadAbsencesMobileError(error) {
  return {
    type: LOAD_ABSENCES_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the AbsenceMobile, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_ABSENCE
 */
export function changeAbsenceMobile(absenceData) {
  return {
    type: CHANGE_ABSENCE,
    absenceData,
  };
}

/**
 * Dispatched when the changeAbsenceMobile are changed/updated by the request saga
 *
 * @param  {array} variables true for AbsenceMobile
 *
 * @return {array} An action object with a type of CHANGE_ABSENCE_SUCCESS passing the variables
 */
export function changeAbsenceMobileSuccess(absenceData) {
  return {
    type: CHANGE_ABSENCE_SUCCESS,
    absenceData,
  };
}

/**
 * Dispatched when loading the changeAbsenceMobile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_ABSENCE_ERROR passing the error
 */
export function changeAbsenceMobileError(error) {
  return {
    type: CHANGE_ABSENCE_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the AbsenceMobile, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_ABSENCE
 */
export function deleteAbsenceMobile(id) {
  return {
    type: DELETE_ABSENCE,
    id,
  };
}

/**
 * Dispatched when the deleteAbsenceMobile are deleted by the request saga
 *
 * @param  {object} variables true for AbsenceMobile
 *
 * @return {object} An action object with a type of DELETE_ABSENCE_SUCCESS passing the variables
 */
export function deleteAbsenceMobileSuccess() {
  return {
    type: DELETE_ABSENCE_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteAbsenceMobile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_ABSENCE_ERROR passing the error
 */
export function deleteAbsenceMobileError(error) {
  return {
    type: DELETE_ABSENCE_ERROR,
    error,
  };
}
